import Button from './Button.component';

export default Button;
